import React, { useEffect, useState } from "react";
import { getItem, getItembySearchWithTotal, getItemGroup, GetPrintData, PostCartItemApi, removeItemInTable, SoPostApi, SqPostApi, UpdateSalesQuotation } from "../APIServices/ItemPageService/ItemPageThunk";
import Header from "../sharedFiles/header/header";
import { useDispatch, useSelector } from "react-redux";
// import BackIcon from "../itemPage copy/BackIcon";
import { calculateGrandTotal, convertColumnNameToPascalCase, errorShowing, getDecryptedUser, handleDeleteRowCommon, showSuccess, useCartUtils } from "./ItemPageShared/ItemUtils";
import SpinnerLoader from "../sharedFiles/loader/spinnerLoader";
import TableView from "./TableView/tableView";
import dayjs from "dayjs";
import { toast, ToastContainer } from "react-toastify";
import SalesQuotationModal from "../salesQuotationModal/salesQuotationModal";
import handlePrinter from "../GenerateReport/generateReport";
import ItemGroup from "../itemPage/CardView/itemGroup";
import ItemList from "../itemPage/CardView/itemList";
import { TablePagination } from "@mui/material";
import ItemCardView from "./CardView/itemCardView";
import Summery from "./ItemPageShared/summery";
import { ItemProvider, UseCart, useCart } from "./ItemPageShared/itemContext";
import BackIcon from "./ItemPageShared/BackIcon";
import Footer from "../sharedFiles/footer/footer";
import { useLocation } from "react-router-dom";

const ItemPage = () => {
    const [isTableView, setIsTableView] = useState(false);
    const location = useLocation();
    const { checked } = location.state || {};
    const [itemSearchTerm, setItemSearchTerm] = useState("");
    const [displayedItem, setDisplayedItem] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const dispatch = useDispatch();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchTerms, setSearchTerms] = useState({});
    const [searchItem, setSearchItem] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [groupCode, setGroupCode] = useState("");
    const [cartUpdated, setCartUpdated] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [orderType, setOrderType] = useState([]);
    const [rows, setRows] = useState([{}]);
    const [inputValue, setInputValue] = useState(() => {
        const storedData = sessionStorage.getItem('CustomerDetails');
        return storedData ? JSON.parse(storedData) : {};
    });
    const { handleQuantityChange } = useCartUtils();
    const hasInputValues = Object.values(inputValue).some(val => val);
    const [isOtherCustomer, setIsOtherCustomer] = useState(hasInputValues ? true : false);
    const [remarks, setRemarks] = useState("");
    const [DueDate, setDueDate] = React.useState(() => dayjs());
    const Ddate = dayjs(DueDate).format("YYYY-MM-DD");
    const [showPrintButton, setShowPrintButton] = useState(false);
    const [callInProgress, setCallInProgress] = useState(
        {
            itemSearch: false,
            historyPage: false,
            checkout: false,
            printing: false,
            getIniItem: false,
            getPasteItems: false,

        });
        
    const userData = getDecryptedUser();
    const userId = userData[0]?.UserId;
    const CardName = userData[0]?.CardName;
    const storedData = sessionStorage.getItem('CustomerDetails');
    const { loading, error, GetItemGrp, GetCartItm, UpdateSq, GetItm, GetItmBySearch, PostSq, PostSo, PrintData, ItemDetailsbyPasting } = useSelector((state) => state.itemPage);
    const isLoading = () => {
        return (
            loading.GetItmBySearch ||
            loading.PostCartItm ||
            loading.PostSo ||
            loading.PostSq ||
            loading.RemoveItmInTable ||
            loading.PrintData ||
            loading.GetItm ||
            loading.UpdateSq ||
            loading.ItemDetailsbyPasting

        );
    };
    const { cart, setCartItems,
        setGrandTotal, grandTotal,
        page, setPage,
        searchResults, setSearchResults } = useCart();
    const handleCheckBox = () => {
        setIsOtherCustomer(prev => !prev);

    };

    const inputfieldLabel = ["customer_Name", "phone_Number", "customer_Address", "margin_Percentage"];

    useEffect(() => {
        if (GetCartItm && Array.isArray(GetCartItm)) {
            setCartItems(prevCart => {
                // Optional: prevent duplicates based on itemCode or any unique key
                const newItems = GetCartItm.filter(
                    newItem => !prevCart.some(existing => existing.itemCode === newItem.itemCode)
                );
                localStorage.setItem("cart", JSON.stringify(newItems));
                return [...prevCart, ...newItems];
            });
        }
        if (!GetItemGrp) {
            dispatch(getItemGroup());
        } else if (GetItemGrp && GetItemGrp.length > 0) {
            if (GetItm?.length > 0) {
                const orderData = GetItm.length;
                setTotalCount(orderData)
            } else {
                fetchData(GetItemGrp[0].itmsGrpCod);
            }
            const group = GetItemGrp[0].itmsGrpCod;
            setGroupCode(group);
            // fetchData(group);
        }
    }, [GetCartItm, GetItemGrp, GetItm]);

    useEffect(() => {
        if (cart.length === 0) {
            const storedCartData = sessionStorage.getItem("cart");
            if (storedCartData) {
                try {
                    const parsedCart = JSON.parse(storedCartData);
                    if (Array.isArray(parsedCart)) {
                        setCartItems(parsedCart);
                    }
                    const Total = calculateGrandTotal(parsedCart);
                    setGrandTotal(Total);
                } catch (e) {
                    console.error("Failed to parse stored cart:", e);
                }
            }
        }
    }, [cart.length]);

    const cleardata = () => {
        setTimeout(() => {
            dispatch(removeItemInTable());
            sessionStorage.removeItem('CustomerDetails')
            setCartItems([]);
            setInputValue({});
            setRemarks('');
            setIsOtherCustomer(false)
            sessionStorage.removeItem('cart');
            setShowPrintButton(true);
            setRows([]);
            setGrandTotal(0);
        }, 500);
    };
    // const [justPasted, setJustPasted] = useState(false);
    const APIChecker = () => {
        if (callInProgress.itemSearch && error.GetItmBySearchError) {
            const errorss = error.GetItmBySearchError;
            toast.error(errorss.errorMessage);
            // errorShowing(errorss);
            setCallInProgress({ ...callInProgress, itemSearch: false });
        }
        if (callInProgress.itemSearch && GetItmBySearch && !loading.GetItmBySearch) {
            setCallInProgress((prev) => ({
                ...prev,
                itemSearch: false,
            }));
            const cartItemCodes = new Set(cart?.map(item => item.item_Code));
            let filteredItems = [];
            if (!TableView) {
                filteredItems = GetItmBySearch.items.filter(
                    item => !cartItemCodes.has(item.item_Code)
                );
            } else {
                filteredItems = GetItmBySearch.items
            }
            if (page > 0) {
                setSearchResults((prevResults) => [...prevResults, ...filteredItems]);
            } else {
                setSearchResults(filteredItems);
            }
            setTotalCount(GetItmBySearch.totalCount);
            setIsDropdownOpen(true);

        }
        
        if (callInProgress.checkout && !(loading.PostSo || loading.PostSq || loading.UpdateSq)) {
            const { PostSoError, PostSqError, UpdateSqError } = error;
            const anyError = PostSoError || PostSqError || UpdateSqError;
            if (anyError) {
                toast.error(anyError.errorMessage);
                // const errorss = (error.PostSoError || error.PostSqError || error.UpdateSqError);
                // errorShowing(anyError);
            } 
            if (callInProgress.checkout && (PostSo || PostSq || UpdateSq)) {
                showSuccess();
                cleardata();
            }
            setCallInProgress({ ...callInProgress, checkout: false });
        }
        if (callInProgress.printing && !loading.PrintData) {
            setCallInProgress({ ...callInProgress, printing: false });
            if (error.PrintDataError) {
                const errorss = error.PrintDataError;
                toast.error(errorss.errorMessage);
                // errorShowing(errorss);
            } else if (callInProgress.printing && PrintData) {
                setIsOtherCustomer(false);
                const orderData = (PostSo || PostSq || UpdateSq);
                const inpData = (PrintData);
                handlePrinter(inpData, orderType, CardName);
                setModalShow(false);
                setShowPrintButton(false);
                sessionStorage.removeItem('CustomerDetails');
            }
        }
        if (callInProgress.getIniItem && !loading.GetItm && TableView) {
            setCallInProgress({ ...callInProgress, getIniItem: false });
            if (error.GetItmError) {
                const errorss = error.GetItmError;
                toast.error(errorss.errorMessage);
                // errorShowing(errorss);
            } else if (GetItm) {
                const orderData = GetItm.length;
                setTotalCount(orderData)
                // setSearchResults(orderData);
            }
        }
        if (callInProgress.getPasteItems && !loading.ItemDetailsbyPasting) {
            if (error.ItemDetailsbyPastingError) {
                const errorss = error.ItemDetailsbyPastingError;
                toast.error(errorss);
                setCallInProgress(prev => ({ ...prev, getPasteItems: false }));
                // } else if (callInProgress.getPasteItems&&ItemDetailsbyPasting) {
                // const updatedCart = cart.map((item, index) => {
                //     const apiItem = ItemDetailsbyPasting[index];
                //     if (!apiItem) return item;
                //     return {
                //       ...apiItem,
                //       item_Code: item.item_Code,
                //       item_Name: item.item_Name,
                //       quantity: item.quantity,
                //     };
                //   });
            } else if (callInProgress.getPasteItems && ItemDetailsbyPasting) {
                const updatedCart = cart.map((item) => {
                    const apiItem = ItemDetailsbyPasting.find(api => api.item_Code === item.item_Code);
                    if (!apiItem) return item;
                    return {
                        ...apiItem,           // overwrite with API data
                        item_Code: item.item_Code,  // keep original item_Code
                        item_Name: item.item_Name,  // keep original item_Name
                        quantity: item.quantity,    // keep original quantity
                    };
                });
                setCartItems(updatedCart);
                updateQuantities();
                setCallInProgress(prev => ({ ...prev, getPasteItems: false }));
            }
        }
    }
    useEffect(() => {
        APIChecker();
    }, [GetItemGrp, callInProgress, TableView, loading, error, PostSo, PostSq, UpdateSq, PrintData, ItemDetailsbyPasting]);
    const updateQuantities = async () => {
        for (let i = 0; i < cart.length; i++) {
            await new Promise(res => setTimeout(res, 10)); // tiny delay
            handleQuantityChange(
                { target: { value: cart[i]?.quantity } },
                i,
                "quantity"
            );
        }
    };


    const handleToggleView = () => {
        setItemSearchTerm('');
        setSearchTerms({});
        if (!isTableView) {
            if (GetItm.length > 0) {
                const orderData = GetItm.length;
                setTotalCount(orderData)
            } else {
                fetchData(GetItemGrp[0].itmsGrpCod);
            }
        }
        setIsTableView(!isTableView);
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            if (itemSearchTerm.length > 2) {
                setSearchItem(true);
                setCallInProgress(prev => ({ ...prev, itemSearch: true }));
                const pageNum = page + 1;
                dispatch(getItembySearchWithTotal({ searchText: itemSearchTerm, pageNumber: pageNum, pageSize: rowsPerPage }));
            } else if (itemSearchTerm === "" && searchItem) {
                setSearchItem(false);
                if (GetItemGrp && GetItemGrp.length > 0 && isTableView) {
                    fetchData(GetItemGrp[0].itmsGrpCod);
                }
            } else {
                setDisplayedItem([]);
            }
        }, 500);

        return () => clearTimeout(handler);
    }, [itemSearchTerm, page]);

    const handleItemSelect = (item, rowIndex, column) => {
        console.log("item", item);

        setSearchTerms({}); // Clear searchTerms
        setIsDropdownOpen(false);
        setCartItems((prevCartItems) => {
            const updatedItems = [...prevCartItems];
            updatedItems[rowIndex] = item;
            sessionStorage.setItem("cart", JSON.stringify(updatedItems));
            return updatedItems;
        });
        if (!TableView) {
            setSearchItem(false);
            setSearchResults([]);
            setItemSearchTerm("");
        }
    };
    const handleDeleteRow = (index) => {
        handleDeleteRowCommon({
            index,
            cart,
            setCartItems,
            setRows,
            setGrandTotal
        });
    };

    const fetchData = async (code) => {
        const setGroupCode = code || groupCode
        setCallInProgress({ ...callInProgress, getIniItem: true });
        setItemSearchTerm("");
        dispatch(getItem({ grpCode: setGroupCode }));
        setPage(0);
        setRowsPerPage(10);
    };

    const handleItemInputChange = (value, page = 0, rowIndex = null, column = null) => {
        //    sessionStorage.removeItem('cart')
        // setCartItems([]);
        const newSearchTerm = value;
        // 1️⃣ Handle table-specific validations only if rowIndex & column exist
        if (rowIndex !== null && column !== null) {
            const columnPascalKeys = convertColumnNameToPascalCase(column);
            if (cart.length === 0 && rowIndex >= 1) {
                alert('Please add a row before entering values.');
                return;
            }
            if (rowIndex > 0) {
                // Check all previous rows (from row 0 to rowIndex - 1)
                for (let i = 0; i < rowIndex; i++) {
                    const prevRow = cart[i];
                    if (!prevRow || !prevRow.item_Code || !prevRow.item_Name) {
                        alert(`Please enter both itemCode and itemName in row ${i + 1} before editing row ${rowIndex + 1}`);
                        return;
                    }
                }
            }
            setRowsPerPage(100);

            // 2️⃣ Table view: Update row-specific search state
            if (newSearchTerm.length === 0) {
                setCartItems((prevCartItems) => {
                    const updatedCartItems = [...prevCartItems];
                    updatedCartItems.splice(rowIndex, 1);
                    sessionStorage.setItem('cart', JSON.stringify(updatedCartItems))
                    return updatedCartItems;
                });

                setSearchTerms((prev) => ({
                    ...prev,
                    [rowIndex]: {
                        ...prev[rowIndex],
                        [columnPascalKeys]: "",
                    },
                }));
            } else {
                setSearchTerms((prev) => ({
                    ...prev,
                    [rowIndex]: {
                        ...prev[rowIndex],
                        [columnPascalKeys]: newSearchTerm,
                    },
                }));
            }
        }
        if (page > 0) {
            setPage(page - 1)
        } else {
            setPage(0);
        }
        setItemSearchTerm(newSearchTerm);
    };

    // #region manual update a cart into SQL table 
    const handlecartUpdate = async () => {
        let userCart = Object.fromEntries(
            Object.entries(cart).map(([key, item]) => {
                let newItem = { ...item, userId }; // Create a new object
                if (!newItem.salUnitMsr) {
                    newItem.salUnitMsr = "0"; // If salUnitMsr will be empty means it will render 0
                }
                if (!newItem.CustomerCode) {
                    newItem.CustomerCode = userData?.CardCode;
                }
                if (!newItem.defaultPriceList) {
                    newItem.defaultPriceList = 0;
                }
                return [key, newItem];
            })
        );

        //****** This will helps to check cart item quantity have value and only a number *********/
        const validatedCart = Object.fromEntries(
            Object.entries(userCart).filter(([key, item]) =>
                Number.isInteger(item.quantity)
            )
        );
        //********* Here will convert a validated abject into array *********/
        const validatedCartArray = Object.values(validatedCart);
        // dispatch(setCart(validatedCart));
        dispatch(PostCartItemApi(validatedCartArray));
        sessionStorage.setItem("cart", JSON.stringify(validatedCart));
    }
    // #endregion
    // #region handle print function 
    const handleprint = async () => {
        const inpData = (PostSo || PostSq || UpdateSq);
        const updateDocEntry = localStorage.getItem('docEntry')
        const DocEntrys = orderType === 'Quote'
            ? inpData.docEntry
            : orderType === 'PurchaseOrder'
                ? inpData.docEntry
                : updateDocEntry;
        setCallInProgress({ ...callInProgress, printing: true });
        dispatch(GetPrintData({ docEntrys: DocEntrys, orderType: orderType }))

    }
    const handlecancel = () => {
        setModalShow(false);
        setShowPrintButton(false);
    }
    // #endregion 
    const handleCheckoutButtonClick = () => {
        const isCartEmpty = cart.length === 0;
        const isQuantityValid = cart.every(item => item.quantity && parseFloat(item.quantity) > 0);

        if (isCartEmpty) {
            console.log("its trigger checkout ", isCartEmpty);
            toast("Your cart is empty. Please add items to proceed.", {
                position: "bottom-right",
                theme: "dark",
            });
            return;
        }

        if (!isQuantityValid) {
            toast("Quantity must be greater than 0 for all items.", {
                position: "bottom-right",
                theme: "dark",
            });
            return;
        }
        // If both validations pass, open the modal
        setModalShow(true);
    }
    console.log("cart", cart);

    // #region final post for sales quatation , sales order, and update SQ 
    const handleCheckout = async (value, shouldNavigate) => {
        setOrderType(value);
        const customerData = { inputValue }
        // localStorage.setItem('CustomerDetails', JSON.stringify(customerData));
        const CustomerDetails = isOtherCustomer
            ? `CustomerName: ${inputValue.customer_Name}, Phone: ${inputValue.phone_Number}, Address: ${inputValue.customer_Address}`
            : '';
        // sessionStorage.setItem('CustomerDetails', (inputValue))

        const marginPercentage = isOtherCustomer
            ? inputValue.margin_Percentage
            : '';
        const isValidNumber = (value) => {
            return typeof value === "number" && !isNaN(value);
        };
        const updatedCart = cart && Object.values(cart)?.map((row) => ({
            customerCode: userData?.CardCode,
            ItemCode: row.item_Code,
            // Price: row.discount_Price
            //     ? row.discount_Price
            //     : row.price || 0,
            Price: row.price,
            discountPercentage: row?.discount_Percentage,
            PriceAfterDiscount: row?.price_After_Discount,
            Quantity: parseInt(row.quantity, 10),
            DeliveryDate: Ddate,
            Remarks: remarks,
            BranchId: userData[0]?.BranchID,
            SplCode: userData[0]?.SalesEmpCode,
            LeadDetail: CustomerDetails,
            MarginPercentage: marginPercentage,

        }))
        const invalidItem = updatedCart.find((item) => {
            return !isValidNumber(item.Quantity) || item.Quantity <= 0;
        });

        if (invalidItem) {
            toast("Quantity must be greater than 0 for all items.", {
                position: "bottom-right",
                theme: "dark",
            });
            return;
        }

        let dataToSend;
        try {
            setCallInProgress({ ...callInProgress, checkout: true });
            if (value === "Quote") {
                dataToSend = {
                    quotationData: updatedCart,
                };

                dispatch(SqPostApi(dataToSend));
            }
            if (value === "PurchaseOrder") {
                dataToSend = {
                    quotationData: updatedCart,
                };
                dispatch(SoPostApi(dataToSend));
            } if (value === "UpdateQuote") {
                dataToSend = {
                    docEntry: cart[0].DocEntry,
                    quotationData: updatedCart,
                };
                dispatch(UpdateSalesQuotation(dataToSend));
            }
        } catch (error) {
            setCallInProgress({ ...callInProgress, checkout: false });
        }
    };
    // #endregion 
    return (
        <>
            <Header
                ItemInputChange={handleItemInputChange}
                show={isTableView ? "show" : ""}
                itemSearchTerm={itemSearchTerm}
            />
            <div className="dashImage"></div>
            <div className="dashGradientIP"></div>

            <BackIcon
                cartUpdated={cartUpdated}
                handlecartUpdate={handlecartUpdate}
                setModalShow={setModalShow}
                setGroupCode={setGroupCode}
                handleToggleView={handleToggleView}
                isTableViews={isTableView}
            />
            <div className="d-flex ItemPage">
                {isTableView ? (
                    <ItemCardView
                        fetchData={fetchData}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        itemSearchTerm={itemSearchTerm}
                        totalCount={totalCount}
                        handleItemSelect={handleItemSelect}
                        handleDeleteRow={handleDeleteRow}
                    />
                ) : (
                    // <div className="ItemPage col-12">
                    <div className="itemDiv col-10 col-sm-10 col-xl-10 col-md-10 col-xxl-10">
                        {/* <div className="gradient col-xl-10 col-8"></div> */}

                        <TableView
                            setSearchTerms={setSearchTerms}
                            searchTerms={searchTerms}
                            setSearchItem={setSearchItem}
                            searchItem={searchItem}
                            searchResults={searchResults}
                            totalCount={totalCount}
                            isDropdownOpen={isDropdownOpen}
                            setDueDate={setDueDate}
                            DueDate={DueDate}
                            handleItemInputChange={handleItemInputChange}
                            setModalShow={setModalShow}
                            setRowsPerPage={setRowsPerPage}
                            remarks={remarks}
                            setRemarks={setRemarks}
                            handleCheckout={handleCheckout}
                            handleItemSelect={handleItemSelect}
                            modalShow={modalShow}
                            inputValue={inputValue}
                            setInputValue={setInputValue}
                            setRows={setRows}
                            rows={rows}
                            setCallInProgress={setCallInProgress}
                            callInProgress={callInProgress}
                            handleDeleteRow={handleDeleteRow}
                        />

                    </div>
                    // </div>
                )}
                <Summery
                    isTableView={isTableView}
                    handleCheckoutButtonClick={handleCheckoutButtonClick}
                    isOtherCustomer={isOtherCustomer}
                    handleCheckBox={handleCheckBox}
                    inputfieldLabel={inputfieldLabel}
                    inputValue={inputValue}
                    setInputValue={setInputValue}
                    setRemarks={setRemarks}
                    remarks={remarks}
                />
            </div>
            <SalesQuotationModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                handlecheckout={handleCheckout}
                handleprint={handleprint}
                handlecancel={handlecancel}
                showPrintButton={showPrintButton}
            />

            {isLoading() &&
                <div className='loader loaderbg position-absolute '>
                    <SpinnerLoader />
                </div>
            }
            <ToastContainer
                position="top-center"
                toastOptions={{
                    style: {
                        fontSize: '16px',
                        padding: '16px',
                        width: '400px',
                        borderRadius: '8px',
                    },
                }}
            />
            <Footer
                className={isTableView ? "footer-itempage" : "footer-Ip"}
                logoPositionClass="logo-item-page"
            />
        </>
    );
};

export default ItemPage;